import React, { useContext, useState } from 'react';
import BuyerUserCard from '../../../elements/BuyerUserCard';
import { CardContainer, PageTitle } from '../../../elements';
import Modal from '../../../elements/Modal';
import { View, ScrollView, Text } from 'react-native';
import {
  AddBuyerUserButton
} from './elements';
import NewBuyerUser from './new';

import AuthContext from 'app/src/contexts/AuthContext';

const CardIndex = props => {
  const { hasPolicy } = useContext(AuthContext);
  const { buyerUsers, buyerId, refetch } = props;
  const [showAddBuyerUserModal, setShowAddBuyerUserModal] = useState(false);

  return (
    <>
      <br />
      <Text><b>Buyer Users</b></Text>
      {hasPolicy({ type: 'BuyerUser', action: 'create' }) && (
        <AddBuyerUserButton
          onPress={() => setShowAddBuyerUserModal(true)}
        >
          <Text>
            + Add Buyer User
          </Text>
        </AddBuyerUserButton>
      )}
      <ScrollView>

        <CardContainer>
          {buyerUsers?.map(buyerUser => {
            return(
              <BuyerUserCard
                buyerUser={buyerUser}
                setShowModal={setShowAddBuyerUserModal}
                key={`buyerUser${buyerUser.id}`}
                refetch={refetch}
              />
            )
          })}
        </CardContainer>
        {showAddBuyerUserModal &&
          <Modal
            showModal={showAddBuyerUserModal}
            setShowModal={setShowAddBuyerUserModal}
            modalType={'Add Buyer User'}
          >
            <NewBuyerUser
              setShowModal={setShowAddBuyerUserModal}
              knownBuyerId={buyerId}
              refetch={refetch}
            />
          </Modal>
        }
      </ScrollView>
    </>
  )
}

export default CardIndex;
